import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import TabCreador from './tabs/TabCreador';
import TabCalidadNH from './tabs/TabCalidadNH';
import TabResponsableArea from './tabs/TabResponsableArea';
import TabRevisionCoordinador from './tabs/TabRevisionCoordinador';
import TabJefeCalidad from './tabs/TabJefeCalidad';
import TabsCalidad, { PanelsCalidad } from './TabsCalidad';
import RechazoModal from './tabs/components/RechazoModal';
import './reclamoCreationContent.scss';
import AdjuntosModal from './tabs/components/AdjuntosModal';
import toast from 'react-hot-toast';
import moment from 'moment';

import CREATE_RECLAMO, { adaptAddGestionReclamoInput } from '../../../data/graphQL/mutations/Reclamo/CreateReclamo';
import GET_RECLAMO_DETALLE, { adaptReclamoCompleto, adaptDelegacionCargada } from '../../../data/graphQL/queries/Reclamos/getReclamoDetalle';
import SUBIR_DOCUMENTOS_RECLAMO, { adaptArchivosArrayInput } from '../../../data/graphQL/mutations/Reclamo/SubirDocumentos';
import GET_ADJUNTOS_RECLAMO, { adaptAdjuntosReclamoArray } from '../../../data/graphQL/queries/Reclamos/getAdjuntosReclamo';
import UPDATE_RECLAMO, { adaptEditGestionReclamoInput } from '../../../data/graphQL/mutations/Reclamo/UpdateReclamo';
import HistorialModal from './tabs/components/HistorialModal';
import GET_FECHA_ETAPA_RESPONSABLE from '../../../data/graphQL/queries/Reclamos/getEtapaResponable';
import { PasswordModal } from "../../CapaCreation/components/tabs/components/PasswordModal";

const CATEGORIA_REC_CLI_ID = 1;
const CATEGORIA_REC_PAC_ID = 2;

const PENDIENTE_CALIDAD = 1;
const PENDIENTE_CREADOR = 2;
const PENDIENTE_RESPONSABLE = 3;
const PENDIENTE_REVISION_COORDINADOR = 4;
const PENDIENTE_JEFE_CALIDAD = 5;

const etapas = {
  [PENDIENTE_CREADOR]: 0,
  [PENDIENTE_CALIDAD]: 1,
  [PENDIENTE_RESPONSABLE]: 2,
  [PENDIENTE_REVISION_COORDINADOR]: 3,
  [PENDIENTE_JEFE_CALIDAD]: 4
};

const idUsuarioLoggeado = sessionStorage.getItem('idUsuario');
const nombreUsuarioLoggeado = `${sessionStorage.getItem('nombre')} ${sessionStorage.getItem('apellido')}`;

export const ReclamoCreationContent = ({ setChildrenAction, setHeaderContent }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    idGestionReclamo, //idGestionReclamo
    id, //numero de reclao o efi
    isNew, //Flag para identificar si es nuevo o edicion
    idEtapa, //idEtapaActual de 
    idEstado, //idEstado actual
    estados, //lista de estados
    allowedWrite //flag para saber si es posible editar
  } = location.state;
  const { tipoGestion } = useParams();

  const [currentTab, setCurrentTab] = useState(null);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [cierraReclamo, setCierraReclamo] = useState(false);
  const [responsableRechazarDisabled, setResponsableRechazarDisabled] = useState(idEtapa === PENDIENTE_RESPONSABLE);
  const [reclamoFormData, setReclamoFormData] = useState({
    stage1: {},
    stage2: {},
    stage3: {
      capa: false
    },
    stage4: {},
    stage5: {},
    adjuntos: []
  });

  const [delegacionCargada, setDelegacionCargada] = useState({});

  const initialTabIndex = useMemo(() => etapas[idEtapa] || 0, [idEtapa]);
  const isReclamo = useMemo(() => tipoGestion === 'reclamos', [tipoGestion]);
  const tabsCalidad = useMemo(() => getTabsCalidad(isReclamo), [isReclamo]);
  const esUsuarioResponsable = useMemo(() => parseInt(idUsuarioLoggeado) === reclamoFormData?.stage2?.idUsuarioResponsable, [idUsuarioLoggeado, reclamoFormData?.stage2?.idUsuarioResponsable]);
  const allowedDismiss = useMemo(() => idEtapa === PENDIENTE_CALIDAD, [idEtapa]);
  const esEtapaCreador = useMemo(() => initialTabIndex === 0, [initialTabIndex]);

  const [getEtapaResponable] = useLazyQuery(GET_FECHA_ETAPA_RESPONSABLE, { fetchPolicy: 'no-cache' });

  const [getReclamo, { data: reclamoDetalleData }] = useLazyQuery(GET_RECLAMO_DETALLE, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    handleChangeTab(initialTabIndex);
  }, [initialTabIndex, tabsCalidad]);

  useEffect(() => {
    if (!reclamoDetalleData) return;


    if (!reclamoDetalleData)
      return toast.error('No se pudo cargar la información del reclamo, intentelo nuevamente más tarde.');

    setReclamoFormData(adaptReclamoCompleto(reclamoDetalleData?.gestionReclamoById));
    setDelegacionCargada(adaptDelegacionCargada(reclamoDetalleData?.gestionReclamoById));
  }, [reclamoDetalleData]);

  const [getAdjuntos, { loading: getAdjuntosLoading, data: adjuntosReclamosData }] = useLazyQuery(GET_ADJUNTOS_RECLAMO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!adjuntosReclamosData) return;

    if (!adjuntosReclamosData?.archivosReclamo)
      return toast.error('No se pudo cargar la información del reclamo, intentelo nuevamente más tarde.');

    setReclamoFormData((prev) => ({
      ...prev,
      adjuntos: adaptAdjuntosReclamoArray(adjuntosReclamosData?.archivosReclamo)
    }));
  }, [adjuntosReclamosData]);

  const [createReclamo, { loading: createLoading }] = useMutation(CREATE_RECLAMO, {
    onCompleted: () => {
      toast.success(`${isReclamo ? 'Reclamo' : 'EFI'} creado con éxito.`);
      navigate(`/calidad/${isReclamo ? 'reclamos' : 'efi'}`);
    }
  });

  const [updateGestionReclamo, { loading: updateLoading }] = useMutation(UPDATE_RECLAMO, {
    onCompleted: () => {
      toast.success(`${isReclamo ? 'Reclamo' : 'EFI'} actualizado con éxito.`);
      navigate(`/calidad/${isReclamo ? 'reclamos' : 'efi'}`);
    },
    onError: () => {
      toast.error('Error al actualizar el reclamo, intentelo nuevamente más tarde');
    }
  });

  const [subirArchivos, { loading: subirArchivosLoading }] = useMutation(SUBIR_DOCUMENTOS_RECLAMO, {
    refetchQueries: [GET_ADJUNTOS_RECLAMO],
    onCompleted: () => {
      toast.success(`Archivos actualizados con éxito.`);
    },
    onError: () => {
      toast.error('Error al cargar los archivos, intentelo nuevamente más tarde');
    }
  });

  const handleStageChange = useCallback((stage, changes) => {
    setReclamoFormData((prev) => ({
      ...prev,
      [`stage${stage}`]: {
        ...prev[`stage${stage}`],
        ...changes
      }
    }));
  }, []);

  // Validación específica por etapa
  const validateStage = useCallback(() => {
    const stage = `stage${initialTabIndex + 1}`;
    const stageData = reclamoFormData[stage];
    const errorMessages = [];

    switch (stage) {
      case 'stage1':
        if (!stageData.fechaRegistro) {
          errorMessages.push('Ocurrió un error, intentelo nuevamente.\n');
          handleStageChange(stage, { fechaRegistro: moment().format('yyyy-MM-DD') });
        }
        if (!stageData.idUsuarioCreador) {
          errorMessages.push('No se pudo cargar el usuario, intentelo nuevamente.\n');
        }
        if (!stageData.idDelegacion) {
          errorMessages.push('Debe elegir una delegación.\n');
        }
        if (!stageData.fechaOcurrencia) {
          errorMessages.push('Debe elegir una fecha de ocurrencia.\n');
        }
        if (moment(stageData.fechaOcurrencia).isAfter(moment())) {
          errorMessages.push('La fecha de ocurrencia no puede ser en el futuro.\n');
        }
        if (isReclamo && !stageData.idCategoriaReclamo) {
          errorMessages.push('Debe elegir una categoría.\n');
        }
        if (isReclamo && stageData.idCategoriaReclamo === CATEGORIA_REC_PAC_ID && !stageData.idPaciente) {
          errorMessages.push('Debe elegir un paciente.\n');
        }
        if (isReclamo && stageData.idCategoriaReclamo === CATEGORIA_REC_CLI_ID && !stageData.idCliente) {
          errorMessages.push('Debe elegir un financiador.\n');
        }
        if (isReclamo && !stageData.idPaciente && !stageData.idCliente) {
          errorMessages.push('Debe cargar al menos un paciente o un financiador.\n');
        }

        if (!isReclamo && !stageData.idPaciente && !stageData.empleado && !stageData.idCliente) {
          errorMessages.push('Debe cargar al menos un paciente, un financiador o un empleado.\n');
        }
        if (!stageData.descripcion?.trim()) {
          errorMessages.push('Debe ingresar una descripción.\n');
        }
        break;
      case 'stage2':
        if (!stageData.idAreaReclamo) {
          errorMessages.push('Debe elegir un área.\n');
        }
        if (!stageData.idClasificacionReclamo) {
          errorMessages.push('Debe elegir una clasificación IR.\n');
        }
        if (!isReclamo && !stageData.idCategoriaEFI) {
          errorMessages.push('Debe elegir una categoría.\n');
        }
        if (!isReclamo && !stageData.justificacion?.trim()) {
          errorMessages.push('Debe ingresar una justificación.\n');
        }
        if (!stageData.descripcionCalidad?.trim()) {
          errorMessages.push('Debe ingresar una descripción.\n');
        }
        if (!stageData.idUsuarioResponsable) {
          errorMessages.push('Debe elegir un usuario responsable.\n');
        }
        break;
      case 'stage3':
        if (!stageData.investigacion?.trim()) {
          errorMessages.push('Debe ingresar un valor para Investigación.\n');
        }
        if (!stageData.accionTomada?.length) {
          errorMessages.push('Debe ingresar al menos una Acción tomada.\n');
        }
        if (!stageData.accionTomada?.every((x) => !!x?.trim())) {
          errorMessages.push('Las acciones tomadas no pueden estar vacías.\n');
        }
        break;
      case 'stage4':
        if (!stageData.descripcionCierre?.trim()) {
          errorMessages.push('Debe ingresar una descripción de cierre.\n');
        }
        if (!!reclamoFormData.stage3?.capa && !stageData.idCapaReclamo) {
          errorMessages.push('Debe ingresar un número de CAPA.\n');
        }
        break;
      case 'stage5':
        if (!stageData.observacionFinal?.trim()) {
          errorMessages.push('Debe ingresar una Observación final.\n');
        }
        break;
      default:
        errorMessages.push('No existe la etapa.');
        break;
    }

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  }, [reclamoFormData, isReclamo, initialTabIndex]);

  const handleSave = useCallback(async () => {
    const stage = initialTabIndex + 1;
    const stageData = reclamoFormData[`stage${stage}`];
    if (!validateStage()) return;

    try {
      const adaptedData = adaptAddGestionReclamoInput(stageData, isReclamo);
      if (isNew) {
        const adaptedArchivos = adaptArchivosArrayInput(reclamoFormData?.adjuntos || []);
        //Creación
        createReclamo({
          variables: {
            input: adaptedData,
            archivos: adaptedArchivos
          }
        });
      } else {
        const adaptedUpdateReclamoByStage = adaptEditGestionReclamoInput(stageData, idGestionReclamo, stage, idEstado, idEtapa);
        updateGestionReclamo({
          variables: {
            input: adaptedUpdateReclamoByStage
          }
        });
      }
    } catch (error) {
      toast.error(error.message);
    }

  }, [reclamoFormData, initialTabIndex, isReclamo]);

  useEffect(() => {
    if (idEtapa !== PENDIENTE_RESPONSABLE) return;
    getEtapaResponable({
      variables: {
        idGestionReclamo: idGestionReclamo
      }
    }).then((res) => {
      const { fechaRealizacion } = res.data.etapaResponable;
      const isLate = fechaRealizacion && moment().diff(moment(fechaRealizacion), 'hours') >= 48;

      setResponsableRechazarDisabled(isLate);
    });
  }, [idEtapa]);

  useEffect(() => {
    if (!idGestionReclamo || isNew) return;
    getReclamo({ variables: { idGestionReclamo: idGestionReclamo } });
    getAdjuntos({ variables: { idGestionReclamo: idGestionReclamo } });
  }, [idGestionReclamo]);

  useEffect(() => {
    // Si el reclamo se encuentra en etapa 5 (jefe de calidad) termina el flujo
    // O
    // Si el reclamo se encuentra en etapa 4 (revision coordinador) y la clasificacion es distinta de 3 (alta) termina el flujo
    var auxValue = reclamoFormData?.idEtapaReclamo === 5 || reclamoFormData?.idEtapaReclamo === 4 && reclamoFormData?.idClasificacionReclamo !== 3;
    setCierraReclamo(auxValue);
  }, [reclamoFormData?.idEtapaReclamo, reclamoFormData?.idClasificacionReclamo]);

  useEffect(() => {
    setChildrenAction(() =>
      <div className='header-actions-calidad'>
        {id > 0 && <div className='chip-estado-calidad'>
          <p>{`N. de ${isReclamo ? 'Reclamo' : 'EFI'}:`} <strong>{` ${id} | ${estados.find((estado) => estado.id === idEstado)?.displayName}`}</strong> </p>
        </div>}
        <div className='top-buttons top-buttons-reclamo-creation'>
          {!isNew && <HistorialModal
            idGestionReclamo={idGestionReclamo}
            esEFI={!isReclamo}
            estados={estados}
            esUsuarioResponsable={esUsuarioResponsable} />
          }
          <AdjuntosModal
            idGestionReclamo={idGestionReclamo}
            idUsuarioLoggeado={parseInt(idUsuarioLoggeado)}
            nombreUsuarioLoggeado={nombreUsuarioLoggeado}
            onSaveAdjuntos={onSaveAdjuntos}
            submitLoading={subirArchivosLoading}
            initialAdjuntos={reclamoFormData?.adjuntos}
            disabled={!allowedWrite}
            queryAdjuntos={getAdjuntos}
            getAdjuntosLoading={getAdjuntosLoading} />

          {!esEtapaCreador && allowedWrite && <>
            <RechazoModal
              isRechazoParcial
              isReclamo={isReclamo}
              idGestionReclamo={idGestionReclamo}
              disabled={responsableRechazarDisabled} />

            {allowedDismiss && <RechazoModal
              isReclamo={isReclamo}
              idGestionReclamo={idGestionReclamo} />
            }
          </>}
          {allowedWrite && <PasswordModal
            onSubmit={handleSave}
            isLoading={createLoading || updateLoading}
            cierraFlujo={cierraReclamo}
            idUsuarioLoggeado={idUsuarioLoggeado} />
          }
        </div>
      </div>
    );
    setHeaderContent(() =>
      <TabsCalidad
        tabs={tabsCalidad}
        currentTabIndex={currentTabIndex}
        initialTabIndex={initialTabIndex}
        handleChangeTab={handleChangeTab} />

    );
  }, [
    setChildrenAction,
    setHeaderContent,
    isReclamo,
    idGestionReclamo,
    estados,
    currentTabIndex,
    initialTabIndex,
    createLoading,
    updateLoading,
    isNew,
    subirArchivosLoading,
    handleSave,
    responsableRechazarDisabled,
    allowedDismiss,
    getAdjuntosLoading]
  );

  //Setear 
  useEffect(() => handleChangeTab(initialTabIndex), [initialTabIndex]);

  const onSaveAdjuntos = useCallback(async (newAdjuntos) => {
    if (isNew) {
      setReclamoFormData((prev) => ({
        ...prev,
        adjuntos: newAdjuntos
      }));
    } else {
      const adaptedArchivos = adaptArchivosArrayInput(newAdjuntos.filter((a) => !a.idArchivo));
      await subirArchivos({
        variables: {
          idGestionReclamo: idGestionReclamo,
          input: adaptedArchivos
        }
      });
    }
  }, [idGestionReclamo]);

  const handleChangeTab = (tabIndex) => {
    setCurrentTabIndex(tabIndex);
    setCurrentTab(tabsCalidad[tabIndex]);
  };

  return (
    <div className='reclamo-creation-general'>
      <PanelsCalidad
        tabs={tabsCalidad}
        initialTabIndex={initialTabIndex}
        etapaCreador={esEtapaCreador}
        delegacionCargada={delegacionCargada}
        currentTabIndex={currentTabIndex}
        reclamoFormData={reclamoFormData}
        handleStageChange={handleStageChange}
        idGestionReclamo={idGestionReclamo}
        isReclamo={isReclamo}
        isEFI={!isReclamo}
        isNew={isNew}
        idUsuarioLoggeado={parseInt(idUsuarioLoggeado)}
        nombreUsuarioLoggeado={nombreUsuarioLoggeado}
        allowedWrite={allowedWrite} />

    </div>);

};


const getTabsCalidad = (isReclamo) => [
  {
    id: 1,
    name: isReclamo ? 'Creador reclamo' : 'Creador de EFI',
    component: <TabCreador />
  },
  {
    id: 2,
    name: 'Calidad NH',
    component: <TabCalidadNH />
  },
  {
    id: 3,
    name: 'Responsable de área',
    component: <TabResponsableArea />
  },
  {
    id: 4,
    name: 'Revisión coordinador',
    component: <TabRevisionCoordinador />
  },
  {
    id: 5,
    name: 'Jefe de calidad',
    component: <TabJefeCalidad />
  }
];